// @gqlflow
import gql from "graphql-tag";

import {gqlOp, type GqlOperation} from "@khan/data-gql-core";

import type {
    FeedbackAnswers as FeedbackAnswersData,
    FeedbackAnswersVariables,
} from "./__graphql-types__/FeedbackAnswers.ts";

export const FEEDBACK_ANSWERS_QUERY: GqlOperation<
    FeedbackAnswersData,
    FeedbackAnswersVariables
> = gqlOp(gql`
    query FeedbackAnswers($parentKey: String!) {
        feedbackByKey(key: $parentKey) {
            ... on QuestionFeedback {
                answers {
                    isLocked
                    isPinned
                    replyCount
                    appearsAsDeleted
                    author {
                        id
                        kaid
                        nickname
                        avatar {
                            name
                            imageSrc
                        }
                    }
                    content
                    date
                    definitelyNotSpam
                    deleted
                    downVoted
                    expandKey
                    feedbackType
                    flaggedBy
                    flags
                    focusUrl
                    focus {
                        kind
                        id
                        translatedTitle
                        relativeUrl
                    }
                    fromVideoAuthor
                    key
                    lowQualityScore
                    notifyOnAnswer
                    permalink
                    qualityKind
                    replyCount
                    replyExpandKeys
                    showLowQualityNotice
                    sumVotesIncremented
                    upVoted
                }
            }
        }
    }
`);
